(function (host) {
  'use strict';

  function variantId(item) { return String(item && (item.variant_id || item.id) || ''); }
  function properties(item) { return item && item.properties || {}; }
  function owned(item) {
    var p = properties(item);
    return String(p._hs_popup_sample || '') === '1' || String(p['Free sample'] || '').trim().toLowerCase() === 'yes';
  }
  function oneTime(item) { return !item.selling_plan_allocation && !item.selling_plan; }
  function normalizeCode(code) { return String(code || '').trim().toUpperCase(); }
  function copy(value) { return value ? JSON.parse(JSON.stringify(value)) : value; }

  function create(options) {
    options = options || {};
    if (typeof options.fetch !== 'function') throw new TypeError('A cart fetch function is required.');
    var request = options.fetch;
    var config = options.config || {};
    var routes = options.routes || {};
    var root = routes.root || config.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var urls = {
      read: routes.cart || root + 'cart.js',
      add: routes.add || root + 'cart/add.js',
      update: routes.update || root + 'cart/update.js'
    };
    var storage = options.storage;
    var storageKey = options.storageKey || 'hs.popupSample.v1';
    var giftIds = new Set((options.giftIds || config.giftIds || []).map(String));
    var managedCodes = new Set((options.managedCodes || config.managedCodes || ['FREESAMPLE']).map(normalizeCode));
    var selection = null;
    var failed = null;
    var adoptLegacy = true;
    var queue = Promise.resolve();
    var queued = 0;
    var state = {cart: null, status: 'idle', selection: null, message: '', blocked: false};
    var messages = Object.assign({
      pending: 'Your sample is saved. Add a product to unlock it.',
      confirmed: 'Your free sample is in your cart.',
      discount: 'Your sample could not be made free. Your choice is saved; please try again.',
      request: 'Your sample could not be updated. Please try again.',
      cleanup: 'Your sample could not be removed. Please refresh your cart before checkout.'
    }, options.messages || {});

    function validSelection(value) {
      if (!value || !/^\d+$/.test(String(value.id)) || !giftIds.has(String(value.id))) return null;
      return {id: String(value.id), name: String(value.name || '').slice(0, 160), handle: String(value.handle || '').slice(0, 160)};
    }
    try {
      var stored = storage && JSON.parse(storage.getItem(storageKey) || 'null');
      if (stored && stored.version === 1) {
        adoptLegacy = false;
        selection = validSelection(stored.selection);
        if (selection && stored.failed && typeof stored.failed.fingerprint === 'string') failed = stored.failed;
      }
    } catch (ignored) {}

    function save() {
      try {
        if (storage) storage.setItem(storageKey, JSON.stringify({version: 1, selection: selection, failed: failed}));
      } catch (ignored) {}
    }
    function selectedCode() {
      var value = selection && typeof options.codeFor === 'function' ? options.codeFor(copy(selection)) : config.code;
      var code = normalizeCode(value);
      if (!code || /[,\r\n]/.test(code)) throw new Error(messages.discount);
      managedCodes.add(code);
      return code;
    }
    function cartShape(cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error(messages.request);
      return cart;
    }
    async function json(url, body) {
      var init = {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}};
      if (body !== undefined) {
        init.method = 'POST';
        init.headers['Content-Type'] = 'application/json';
        init.body = JSON.stringify(body);
      }
      var response = await request(url, init);
      var data;
      try { data = await response.json(); } catch (ignored) { throw new Error(messages.request); }
      if (!response.ok) throw new Error(data.description || data.message || messages.request);
      return data;
    }
    async function read() { return cartShape(await json(urls.read)); }
    function codes(cart) {
      var result = [];
      (cart.discount_codes || []).forEach(function (discount) {
        var code = normalizeCode(discount.code);
        if (code && result.indexOf(code) === -1) result.push(code);
      });
      return result;
    }
    async function discounts(cart, desired) {
      var before = codes(cart);
      var next = before.filter(function (code) { return !managedCodes.has(code); });
      if (desired && next.indexOf(desired) === -1) next.push(desired);
      if (before.slice().sort().join(',') === next.slice().sort().join(',')) return cart;
      await json(urls.update, {discount: next.join(',')});
      return read();
    }
    function qualifies(item, cart) {
      if (owned(item) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
          !Number.isSafeInteger(item.final_line_price) || item.final_line_price <= 0 || item.gift_card) return false;
      var p = properties(item);
      if (String(p._free || '') === '1' || String(p._gift || '') === '1' ||
          item.handle === 'free-sample-gift' || item.handle === 'free-bottle-gift') return false;
      var protectionId = options.protectionVariantId || config.protectionVariantId;
      var protectionHandle = options.protectionHandle || config.protectionHandle;
      if ((protectionId && variantId(item) === String(protectionId)) || (protectionHandle && item.handle === protectionHandle)) return false;
      if (typeof options.qualifies === 'function') return options.qualifies(item, cart) === true;
      var catalog = options.catalog || config.catalog || {};
      var entry = catalog[variantId(item)];
      return !!entry && ['bodywash', 'soap', 'rollon', 'curated', 'mix', 'bundle'].indexOf(entry.kind || entry.category || entry) !== -1;
    }
    function hasQualifier(cart) { return cart.items.some(function (item) { return qualifies(item, cart); }); }
    function proof(item, cart, code) {
      if (!item || !owned(item) || !selection || variantId(item) !== selection.id || item.quantity !== 1 ||
          !oneTime(item) || item.final_line_price !== 0 || !Number.isSafeInteger(item.original_line_price) || item.original_line_price <= 0) return false;
      if (!(cart.discount_codes || []).some(function (discount) { return normalizeCode(discount.code) === code && discount.applicable === true; })) return false;
      var allocations = item.line_level_discount_allocations || [];
      if (!allocations.every(function (allocation) { return Number.isSafeInteger(allocation.amount) && allocation.amount >= 0; })) return false;
      if (allocations.reduce(function (sum, allocation) { return sum + allocation.amount; }, 0) !== item.original_line_price) return false;
      if (item.line_level_total_discount !== undefined && item.line_level_total_discount !== item.original_line_price) return false;
      if (item.total_discount !== undefined && item.total_discount !== item.original_line_price) return false;
      return allocations.filter(function (allocation) {
        var discount = allocation.discount_application || {};
        return allocation.amount === item.original_line_price &&
          discount.type === 'discount_code' && normalizeCode(discount.title) === code &&
          discount.target_type === 'line_item' && discount.value_type === 'percentage' && Number(discount.value) === 100;
      }).length === 1;
    }
    function fingerprint(cart, code) {
      var lines = cart.items.filter(function (item) { return !owned(item); }).map(function (item) {
        var plan = item.selling_plan_allocation;
        var p = properties(item);
        return [variantId(item), item.quantity, item.final_line_price, plan && plan.selling_plan && plan.selling_plan.id || '',
          Object.keys(p).sort().map(function (key) { return [key, p[key]]; })];
      });
      lines.sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); });
      return JSON.stringify([selection && selection.id, code, cart.currency || '', lines,
        codes(cart).filter(function (value) { return !managedCodes.has(value); }).sort()]);
    }
    function finish(cart, status, message, blocked) {
      state = {cart: cart, status: status, selection: copy(selection), message: message || '', blocked: !!blocked};
      if (typeof options.onState === 'function') {
        try { options.onState(state); } catch (ignored) {}
      }
      return state;
    }
    async function normalizeOwned(cart, keepSelected) {
      var kept = false;
      var updates = {};
      cart.items.filter(owned).forEach(function (item) {
        var keep = keepSelected && !kept && selection && variantId(item) === selection.id && oneTime(item);
        if (keep) kept = true;
        var quantity = keep ? 1 : 0;
        if (item.quantity !== quantity) {
          if (!item.key) throw new Error(messages.cleanup);
          updates[item.key] = quantity;
        }
      });
      if (Object.keys(updates).length) {
        await json(urls.update, {updates: updates});
        cart = await read();
      }
      var remaining = cart.items.filter(owned);
      if ((!keepSelected && remaining.length) || (keepSelected && (remaining.length > 1 || remaining.some(function (item) {
        return variantId(item) !== selection.id || !oneTime(item) || item.quantity !== 1;
      })))) throw new Error(messages.cleanup);
      return cart;
    }
    async function reconcile(input, force, adopt) {
      var cart;
      var code = '';
      try {
        cart = input ? cartShape(input) : await read();
        if (!selection && adopt && adoptLegacy) {
          var legacy = cart.items.find(function (item) { return owned(item) && giftIds.has(variantId(item)); });
          if (legacy) {
            selection = validSelection({id: variantId(legacy), name: legacy.product_title || legacy.title, handle: legacy.handle});
            adoptLegacy = false;
            save();
          }
        }
        if (selection) code = selectedCode();
        var stamp = fingerprint(cart, code);
        if (!force && failed && failed.fingerprint === stamp) {
          return finish(cart, 'error', failed.message, failed.blocked || cart.items.some(owned));
        }
        if (!selection || !hasQualifier(cart)) {
          cart = await normalizeOwned(cart, false);
          cart = await discounts(cart, null);
          if (!selection || !hasQualifier(cart)) {
            failed = null;
            save();
            return finish(cart, selection ? 'pending' : 'idle', selection ? messages.pending : '');
          }
        }
        cart = await normalizeOwned(cart, true);
        var sample = cart.items.find(owned);
        if (sample && proof(sample, cart, code)) {
          failed = null;
          save();
          return finish(cart, 'confirmed', messages.confirmed);
        }
        if (sample) {
          cart = await normalizeOwned(cart, false);
          sample = null;
        }
        cart = await discounts(cart, null);
        if (!sample) {
          await json(urls.add, {items: [{id: selection.id, quantity: 1, properties: {_hs_popup_sample: '1'}}]});
          cart = await read();
        }
        if (!hasQualifier(cart)) {
          cart = await normalizeOwned(cart, false);
          cart = await discounts(cart, null);
          failed = null;
          save();
          return finish(cart, 'pending', messages.pending);
        }
        await json(urls.update, {discount: codes(cart).filter(function (value) { return !managedCodes.has(value); }).concat(code).join(',')});
        cart = await read();
        var ownedItems = cart.items.filter(owned);
        if (!hasQualifier(cart) || ownedItems.length !== 1 || !proof(ownedItems[0], cart, code)) throw new Error(messages.discount);
        failed = null;
        save();
        return finish(cart, 'confirmed', messages.confirmed);
      } catch (error) {
        var blocked = false;
        try {
          cart = await read();
          cart = await normalizeOwned(cart, false);
          cart = await discounts(cart, null);
        } catch (cleanupError) {
          blocked = true;
          try { cart = await read(); } catch (ignored) {}
        }
        var message = blocked ? messages.cleanup : error.message || messages.request;
        failed = {fingerprint: cart ? fingerprint(cart, code) : '', message: message, blocked: blocked};
        save();
        return finish(cart || null, 'error', message, blocked);
      }
    }
    function enqueue(action, cart) {
      var readFresh = queued > 0;
      queued++;
      var result = queue.then(function () { return action(readFresh ? null : cart); });
      var settled = result.finally(function () { queued--; });
      queue = settled.catch(function () {});
      return settled;
    }
    function select(value, cart) {
      var next = validSelection(value);
      if (!next) return Promise.reject(new Error('Choose an available sample.'));
      return enqueue(function (current) {
        selection = next;
        adoptLegacy = false;
        failed = null;
        save();
        return reconcile(current, true, false);
      }, cart);
    }
    function clear(cart) {
      return enqueue(function (current) {
        selection = null;
        adoptLegacy = false;
        failed = null;
        save();
        return reconcile(current, true, false);
      }, cart);
    }
    return {
      select: select,
      sync: function (cart) { return enqueue(function (current) { return reconcile(current, false, true); }, cart); },
      clear: clear,
      getSelection: function () { return copy(selection); },
      getState: function () { return Object.assign({}, state, {selection: copy(selection)}); },
      pending: function () { return queued > 0; },
      owns: owned
    };
  }
  host.HypeScentSampleReward = {create: create, owns: owned};
  if (typeof module === 'object' && module.exports) module.exports = host.HypeScentSampleReward;
})(typeof window === 'object' ? window : globalThis);
